<template>
  <div class="cash-withdrawal" style="padding-top: 1rem">
    <!--<navTitle title="佣金提现"></navTitle>-->
    <navTitle
      :title="
        $router.app._route.query.ti ? $router.app._route.query.ti : 'Commission withdrawal'
      "
    ></navTitle>

    <div class="nav acea-row">
      <div
        v-for="(item, index) in navList"
        class="item"
        @click="swichNav(index, item)"
        :key="index"
        :class="currentTab == index ? 'click' : ''"
      >
        <div>{{ item.name }}</div>
      </div>
    </div>

    <div class="wrapper">
      <!--提现到电子钱包-->
      <div :hidden="currentTab !== 0" class="list" style="position: relative">
        <div
          class="isnull"
          v-if="showTips === 'true'"
          style="position: absolute"
        >
          You have not link e-wallet yet, please link and submit withdrawal application again.
          <div
            class="isnull-btn"
            @click="$router.push({ path: '/user/myPay' })"
          >
            Link now
          </div>
        </div>
        <div v-if="showTips === 'false'">
          <div class="item acea-row row-between-wrapper">
            <div class="name">Service provider</div>
            <div class="input">
              <select v-model="cashId">
                <option value="">Please select withdrawal account</option>
                <option
                  v-for="(item, index) in cashList"
                  :key="index"
                  :value="item.id"
                  >{{ item.type }}</option
                >
              </select>
            </div>
          </div>

          <div class="item acea-row row-between-wrapper">
            <div class="name">Account</div>
            <div class="input">
              <input
                placeholder="Please select withdrawal account"
                disabled="disabled"
                v-model="cashUserName"
              />
            </div>
          </div>

          <div class="item acea-row row-between-wrapper">
            <div class="name">Withdraw</div>
            <div class="input">
              <input
                :placeholder="'Minimum '+minPrice+' to withdraw' "
                v-model="post.money"
              />
            </div>
          </div>
          <div class="tip">Current commission available for withdrawal: {{ commissionCount }}</div>
          <div class="bnt bg-color-red" @click="submitted">withdraw </div>
        </div>
      </div>
      <!--提现到银行卡-->
      <!--<div :hidden="currentTab !== 0" class="list">-->
      <!--<div class="item acea-row row-between-wrapper">-->
      <!--<div class="name">持卡人</div>-->
      <!--<div class="input">-->
      <!--<input placeholder="请输入持卡人姓名" v-model="post.name" />-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="item acea-row row-between-wrapper">-->
      <!--<div class="name">卡号</div>-->
      <!--<div class="input">-->
      <!--<input placeholder="请填写卡号" v-model="post.cardnum" />-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="item acea-row row-between-wrapper">-->
      <!--<div class="name">银行</div>-->
      <!--<div class="input">-->
      <!--<select v-model="post.bankname">-->
      <!--<option value="">请选择银行</option>-->
      <!--<option-->
      <!--v-for="(item, index) in banks"-->
      <!--:key="index"-->
      <!--value="item"-->
      <!--&gt;{{ item }}</option-->
      <!--&gt;-->
      <!--</select>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="item acea-row row-between-wrapper">-->
      <!--<div class="name">提现</div>-->
      <!--<div class="input">-->
      <!--<input-->
      <!--:placeholder="'最低提现金额' + minPrice"-->
      <!--v-model="post.money"-->
      <!--/>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="tip">当前可提现金额: {{ commissionCount }}</div>-->
      <!--<div class="bnt bg-color-red" @click="submitted">提现</div>-->
      <!--</div>-->
      <!--提现到余额-->
      <div :hidden="currentTab !== 1" class="list">
        <div class="item acea-row row-between-wrapper">
          <div class="name">withdraw </div>
          <div class="input">
            <input
              :placeholder='"Minimum "+minPrice+"to withdraw" '
              v-model="post.money"
            />
          </div>
        </div>
        <div class="tip">Current withdrawal commission: {{ commissionCount }}</div>
        <div class="bnt bg-color-red" @click="submitted">withdraw </div>
      </div>
      <div :hidden="currentTab !== 2" class="list">
        <div class="item acea-row row-between-wrapper">
          <div class="name">Account</div>
          <div class="input">
            <input placeholder="Please fill in your alipay user name" v-model="post.name" />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">Account</div>
          <div class="input">
            <input
              placeholder="Please fill in your alipay account number"
              v-model="post.alipay_code"
            />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">withdraw </div>
          <div class="input">
            <input
              :placeholder='"Minimum "+minPrice+"to withdraw" '
              v-model="post.money"
            />
          </div>
        </div>
        <div class="tip">Current withdrawal commission: {{ commissionCount }}</div>
        <div class="bnt bg-color-red" @click="submitted">withdraw </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBank, postCashInfo } from "../../../api/user";
import { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import navTitle from "@components/navTitle";

export default {
  name: "UserCash",
  components: { navTitle },
  props: {},
  watch: {
    cashId(n) {
      let list = this.cashList;
      list.forEach(item => {
        if (item.id == n) {
          this.cashUserName = item.account;
        }
      });
    }
  },
  data: function() {
    return {
      navList: [
        { name: "Withdraw to E-wallet", type: "bank", icon: "icon-yinhangqia" },
        // { name: "提现到银行卡", type: "bank", icon: "icon-yinhangqia" },
        { name: "Withdraw to balance", type: "balance", icon: "icon-weixin2" }
      ],
      cashList: [],
      cashId: "",
      cashUserName: "",
      showTips: "",
      post: {
        extract_type: "bank",
        alipay_code: "",
        money: "",
        name: "",
        bankname: "",
        cardnum: "",
        weixin: ""
      },
      currentTab: 0,
      minPrice: 0,
      banks: [],
      commissionCount: 0
    };
  },
  mounted: function() {
    this.getBank();
  },
  methods: {
    swichNav: function(index, item) {
      this.currentTab = index;
      this.post.extract_type = item.type;
    },
    getBank: function() {
      let that = this;
      this.$dialog.loading.open("Loading...");
      getBank().then(
        res => {
          this.$dialog.loading.close();

          that.banks = res.data.extractBank;
          that.minPrice = res.data.minPrice;
          that.commissionCount = res.data.commissionCount;
          // console.log(res.data.my_cash);
          that.cashList = res.data.my_cash;
          let cashList = res.data.my_cash;
          for(let i=0;i<cashList.length;i++){
            if(cashList[i].type == 'PayMaya'){
              res.data.my_cash.splice(i,1)
            }
            if(cashList[i].type == 'TopPay'){
              res.data.my_cash.splice(i,1)
            }
          }
          if (cashList.length > 0) {
            this.showTips = "false";
          } else {
            this.showTips = "true";
          }
        },
        function(err) {
          this.$dialog.loading.close();

          that.$dialog.message(err.msg);
        }
      );
    },
    async submitted() {
      let bankname = this.post.bankname,
        alipay_code = this.post.alipay_code,
        money = this.post.money,
        name = this.post.name,
        cardnum = this.post.cardnum,
        weixin = this.post.weixin,
        cashId = this.cashId,
        that = this;
      if (
        parseFloat(money) > parseFloat(that.commissionCount) ||
        parseFloat(that.commissionCount) == 0
      )
        return that.$dialog.message("Insufficient balance");
      if (parseFloat(money) < parseFloat(that.minPrice))
        return that.$dialog.message("Minimum "+that.minPrice+"to withdraw" );
      switch (that.post.extract_type) {
        case "bank":
          that.save({
            extract_type: that.post.extract_type,
            cash_id: cashId,
            money: money
          });
          break;
        case "banks":
          try {
            await this.$validator({
              name: [required.message("Name of cardholder")],
              cardnum: [required(required.message("The card number"))],
              bankname: [required(required("Please choose a withdrawal bank"))],
              money: [required.message("Withdrawal amount")]
            }).validate({ bankname, cardnum, name, money });
            let save = {
              extract_type: that.post.extract_type,
              bankname: bankname,
              cardnum: cardnum,
              name: name,
              money: money
            };
            that.save(save);
          } catch (e) {
            return validatorDefaultCatch(e);
          }
          break;
        case "alipay":
          try {
            await this.$validator({
              name: [required(required.message("Alipay user name"))],
              alipay_code: [required(required.message("Alipay account number"))],
              money: [required(required.message("Withdrawal amount"))]
            }).validate({ name, alipay_code, money });
            let save = {
              extract_type: that.post.extract_type,
              alipay_code: alipay_code,
              name: name,
              money: money
            };
            that.save(save);
          } catch (e) {
            return validatorDefaultCatch(e);
          }
          break;
        case "balance":
          try {
            await this.$validator({
              money: [required(required.message("Withdrawal amount"))]
            }).validate({ money });
            let save = {
              extract_type: that.post.extract_type,
              money: money
            };
            that.save(save);
          } catch (e) {
            return validatorDefaultCatch(e);
          }
          break;
      }
    },
    save: function(info) {
      // console.log(info)
      postCashInfo(info).then(
        res => {
          this.$dialog.message(res.msg);
          this.$router.push({ path: "/user/audit" });
        },
        error => {
          this.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
